import React, { useCallback, useMemo } from "react";
import "./CategoriesRaccomandations.css";
import { useDispatch, useSelector } from "react-redux";
import {
  SetSliderValue,
  SetUrlPrefix,
  SetImgPrefix,
  SetSliderValueMinMax,
  SetIsExpanded,
  SetIsSearching,
  SetPrevProducts,
  SetActiveFilters,
  SetAsyncData,
  SetListingBanner,
  SetProducts,
  SetResultsCount,
  SetFilters,
  SetMasterCategories,
  SetPages,
  SetPage,
  SetSuggestedWords,
} from "../../state/actions/index";
import Utils from "../../utils/Utils";
import axios from "axios";
import PerfectScrollbar from "react-perfect-scrollbar";

const CategoriesRaccomandations = () => {
  // const triggers = useSelector(state => state.config.triggers);
  const raccomandationsCategories = useSelector(
    (state) => state.config.triggers.raccomandationsCategories
  );
  const card = useSelector((state) => state.config.card);
  const placeholders = useSelector((state) => state.config.placeholders);
  const configFilters = useSelector((state) => state.config.filters);
  const isMobile = useSelector((state) => state.isMobile);
  const searchWord = useSelector((state) => state.searchWord);
  const sort = useSelector((state) => state.sort);
  const products = useSelector((state) => state.products);
  const defaultCategories = useSelector((state) => state.defaultCategories);
  // const display = useSelector(state => state.config.display);
  const activeFilters = useSelector((state) => state.activeFilters);
  const config = useSelector((state) => state.config);
  const sliderValueMinMax = useSelector((state) => state.sliderValueMinMax);
  const sliderValue = useSelector((state) => state.sliderValue);
  const dispatch = useDispatch();

  const categoryKey = useMemo(() => {
    var valueToReturn = "";
    Object.keys(configFilters).forEach((filter) => {
      if (configFilters[filter].isCategory) valueToReturn = filter;
    });
    return valueToReturn;
  }, [configFilters]);

  const queryOptions = useSelector((state) => state.config.queryOptions);
  var rows = useMemo(
    () => (isMobile ? queryOptions.rows.mobile : queryOptions.rows.desktop),
    [isMobile, queryOptions]
  );
  var raccomandationsCategoriesResponsive = useMemo(
    () =>
      isMobile
        ? raccomandationsCategories.mobile
        : raccomandationsCategories.desktop,
    [isMobile, raccomandationsCategories]
  );
  // var wordsHistoryResponsive=useMemo(()=>isMobile?triggers.wordsHistory.mobile:triggers.wordsHistory.desktop,[triggers,isMobile]);
  // var categoryTilesResponsive=useMemo(()=>isMobile?triggers.categoryTiles.mobile:triggers.categoryTiles.desktop,[triggers,isMobile]);

  const selectMasterCategory = useCallback(
    (value) => {
      var tempActiveFilters = activeFilters;
      tempActiveFilters.push({
        key: categoryKey,
        value:
          value +
          (Utils.checkLastCategory(Object.keys(defaultCategories), value, true)
            ? ""
            : "*"),
      });
      dispatch(SetActiveFilters(tempActiveFilters));
      dispatch(SetIsSearching(true));
      dispatch(SetAsyncData([]));
      var priceGroup = {};
      priceGroup.id =
        window.AS_ADVANCED_CONFIG && window.AS_ADVANCED_CONFIG.visitorType
          ? window.AS_ADVANCED_CONFIG.visitorType
          : config.priceGroup.id;
      priceGroup.currency =
        window.AS_ADVANCED_CONFIG && window.AS_ADVANCED_CONFIG.currencyCode
          ? window.AS_ADVANCED_CONFIG.currencyCode
          : config.priceGroup.currency;
      var localSearchUrl = Utils.getSearchUrl(
        config.baseUrl,
        config.queryOptions,
        priceGroup,
        config.shopId,
        config.jsonFast
      );
      axios
        .get(
          Utils.insertWordInSearchUrl(
            localSearchUrl,
            searchWord,
            tempActiveFilters,
            sort,
            1,
            configFilters,
            rows
          )
        )
        .then((res) => {
          var response = res.data;
          dispatch(SetIsExpanded({}));
          dispatch(SetPrevProducts(products));
          dispatch(
            SetProducts(
              Utils.refactorUrl(
                response.data,
                response.header.imagePrefix,
                response.header.urlPrefix,
                card.img,
                card.url
              )
            )
          );
          dispatch(SetResultsCount(response.header.results_count));
          dispatch(
            SetSliderValueMinMax(
              Utils.addSliderValue(response, sliderValueMinMax)
            )
          );
          dispatch(SetSliderValue(Utils.addSliderValue(response, sliderValue)));
          dispatch(SetFilters(response));
          dispatch(SetSuggestedWords(response.suggestions));
          dispatch(
            SetPages(parseInt((response.header.results_count - 1) / rows) + 1)
          );
          dispatch(SetPage(1));
          dispatch(SetListingBanner(response.banners[0]));
          dispatch(SetMasterCategories([]));
          dispatch(SetUrlPrefix(response.header.urlPrefix));
          dispatch(SetImgPrefix(response.header.imagePrefix));
          if (config.webhook.key !== "")
            Utils.getAsyncData(config.webhook, response.data, priceGroup).then(
              (value) => dispatch(SetAsyncData(value.asyncData))
            );
        })
        .finally(() => dispatch(SetIsSearching(false)));
    },
    [
      dispatch,
      searchWord,
      activeFilters,
      sort,
      rows,
      sliderValueMinMax,
      sliderValue,
      config,
      configFilters,
      defaultCategories,
      products,
      categoryKey,
      card,
    ]
  );

  return (
    <div
      className={
        "categories-raccomandations "
        // +(categoryTilesResponsive.length>0 || wordsHistoryResponsive.isActive || triggers.raccomandationsProducts.length>0?"lateral":"")}>
      }
    >
      <div className="label "> {placeholders.labelTrendingCategories} </div>
      {
        //   !isMobile && display!=="half-screen"?<div className="list">
        //   {raccomandationsCategoriesResponsive.map((item,index)=>
        //     <div className="item" key={"category_raccomandation_"+index} onClick={()=>selectMasterCategory(item.key)}> {item.value} </div>
        //   )}
        // </div>:
        <PerfectScrollbar options={{ suppressScrollX: false }} className="list">
          {raccomandationsCategoriesResponsive.map((item, index) => (
            <div
              className="item"
              key={"category_raccomandation_" + index}
              onClick={() => selectMasterCategory(item.value)}
            >
              {" "}
              {item.name}{" "}
            </div>
          ))}
        </PerfectScrollbar>
      }
    </div>
  );
};

export default CategoriesRaccomandations;
